/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/DocumentEnhancer.yaml
import { ScanbotDocumentEnhancerImpl } from './impl';
/**
 * Entry point for all Document Enhancer features.
 */
export const ScanbotDocumentEnhancer = {
    /**
     * Straightens the document effectively straightening its edges and text.
     * @param {ImageInput} params.image - The image of the document to straighten.
     * @param {DocumentStraighteningParameters} params.straighteningParameters - The parameters to use for straightening.
     * @param {Point[]} params.priorCornersNormalized - If the corners are already known (e.g. from a prior detection), they can be provided here. The enhancer may take them into account to locate the document more accurately.
     * @returns {Promise<DocumentStraighteningResult>} - The result of the straightening operation.
     */
    async straightenImage(params) {
        return ScanbotDocumentEnhancerImpl.straightenImage(params);
    },
};
//# sourceMappingURL=DocumentEnhancer.js.map